import * as React from 'react';

import { useBetslipContext } from '~/providers/betslip-context';
import { useServicesContext } from '~/providers/services-context';

import styles from '../style/stake-input.module.css';

export const blacklistedKeys = [
  'e',
  'E',
  '+',
  '-',
  '/',
  '*',
  '(',
  ')',
  '&',
  '$',
  '^',
  ',',
  '@',
  '"',
  ';',
  ':',
  '=',
  '!',
  '`',
  '~',
  '#',
  '|',
  '€',
  '%',
  '{',
  '}',
  '[',
  ']',
  '£',
  "'",
]; // Safari made me do this

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  placeholder?: string;
  returns?: React.ReactElement;
  stake?: number;
}

export const StakeInput = ({ placeholder, returns, stake, ...inputProps }: InputProps) => {
  const { labelActions } = useServicesContext();
  const { changeStake } = useBetslipContext();

  const value = stake === 0 ? '' : stake;

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (blacklistedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const newValue = value.replace(/[^0-9.]+/g, '');
    if (
      (newValue === '' || newValue.match(/(^[0-9]{1,6})+(\.[0-9]{1,2})?$/) || newValue[newValue.length - 1] === '.') &&
      changeStake
    ) {
      changeStake(Number(value));
    }
  };

  return (
    <>
      <div className={styles.sectionWrapper}>
        <div className={styles.stakeTitle}>{labelActions.get('Stake')}:</div>
        <input
          aria-label="Stake input"
          className={styles.input}
          min="0"
          placeholder={placeholder}
          type="number"
          value={value}
          {...inputProps}
          data-testid="betslip-stake-input"
          onChange={handleChange}
          onKeyDown={handleKeyPress}
        />
      </div>
      <div className={styles.sectionWrapper}>
        <div className={styles.returnsTitle}>{labelActions.get('RETURNS')}</div>
        <div className={styles.returns}>{returns}</div>
      </div>
    </>
  );
};
